module.exports = __webpack_public_path__ + "img/rise_shadow.7b208eee.png";